import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import { productAccessorStockStatusIsAvailable } from './productAccessorStockStatusIsAvailable'

export const productAccessorSomeVariantStockStatusIsAvailable = (
  product: PimProductWithVariantsV1,
): boolean => {
  return product.variants.some((productVariant) =>
    productAccessorStockStatusIsAvailable(productVariant),
  )
}
